import React, { useState, useEffect, useCallback } from 'react'
import { supabase } from '../supabaseClient'
import { parseCsvLeads } from '../utils/parseCsvLeads'
import './LeadsCapacitacao.css'

const STATUS_OPCOES = [
  { value: '', label: 'Todos os status' },
  { value: 'Novo', label: 'Novo' },
  { value: 'Contato feito', label: 'Contato feito' },
  { value: 'Recusado', label: 'Recusado' },
  { value: 'Fechado', label: 'Fechado' }
]

const STATUS_SELECT_OPCOES = STATUS_OPCOES.filter((o) => o.value)

const STATUS_CORES = {
  novo: '#0056b3',
  'contato-feito': '#198754',
  recusado: '#dc3545',
  fechado: '#6c757d'
}

const getStatusColor = (status) => {
  const s = (status || 'novo').toLowerCase().replace(/\s/g, '-')
  return STATUS_CORES[s] || STATUS_CORES.novo
}

const formatarMoeda = (v) => {
  if (v == null || v === '' || isNaN(parseFloat(v))) return '—'
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(v))
}

const formatarMoedaInput = (value) => {
  const numbers = String(value || '').replace(/\D/g, '')
  if (!numbers) return ''
  const amount = parseFloat(numbers) / 100
  return amount.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

const parseMoedaBR = (value) => {
  if (!value || !String(value).trim()) return null
  const cleanValue = String(value).replace(/\./g, '').replace(',', '.')
  const n = parseFloat(cleanValue)
  return isNaN(n) ? null : n
}

const formatarCpf = (cpf) => {
  const n = String(cpf || '').replace(/\D/g, '')
  if (n.length !== 11) return cpf
  return n.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

const APROVADO_FINANCIADORA_OPCOES = [
  { value: '', label: 'Todos' },
  { value: 'Sim', label: 'Sim' },
  { value: 'Não', label: 'Não' },
  { value: '__sem__', label: 'Sem informação' }
]

const LeadsCapacitacao = ({ onBack, userId, userName, userEmpresa, userRole }) => {
  const [empresas, setEmpresas] = useState([])
  const [bancos, setBancos] = useState([])
  const [separador, setSeparador] = useState(',')
  const [idEmpresa, setIdEmpresa] = useState('')
  const [loading, setLoading] = useState(false)
  const [resultado, setResultado] = useState(null)
  const [erro, setErro] = useState('')
  const [leads, setLeads] = useState([])
  const [loadingLeads, setLoadingLeads] = useState(true)
  const [filtroStatus, setFiltroStatus] = useState('')
  const [filtroAprovadoFinanc, setFiltroAprovadoFinanc] = useState('')
  const [filtroNome, setFiltroNome] = useState('')
  const [filtroCpf, setFiltroCpf] = useState('')
  const [filtroNomeDebounce, setFiltroNomeDebounce] = useState('')
  const [filtroCpfDebounce, setFiltroCpfDebounce] = useState('')
  const [modalStatus, setModalStatus] = useState({ show: false, lead: null })
  const [historico, setHistorico] = useState([])
  const [editStatus, setEditStatus] = useState('')
  const [editObservacao, setEditObservacao] = useState('')
  const [salvandoStatus, setSalvandoStatus] = useState(false)
  const [modalFinanc, setModalFinanc] = useState({ show: false, lead: null })
  const [editAprovado, setEditAprovado] = useState('')
  const [editBanco, setEditBanco] = useState('')
  const [editValor, setEditValor] = useState('')
  const [salvandoFinanc, setSalvandoFinanc] = useState(false)

  useEffect(() => {
    const t = setTimeout(() => setFiltroNomeDebounce(filtroNome), 400)
    return () => clearTimeout(t)
  }, [filtroNome])
  useEffect(() => {
    const t = setTimeout(() => setFiltroCpfDebounce(filtroCpf), 400)
    return () => clearTimeout(t)
  }, [filtroCpf])

  const carregarLeads = useCallback(async () => {
    setLoadingLeads(true)
    try {
      let q = supabase
        .from('leads_capacitacao')
        .select('id, cpf, nome, data_nascimento, telefone, status, observacao, aprovado_financiadora, banco_financiadora, valor_financiadora, data_cadastrado')
        .order('data_cadastrado', { ascending: false })

      if (filtroStatus) q = q.eq('status', filtroStatus)
      if (filtroAprovadoFinanc === 'Sim') q = q.eq('aprovado_financiadora', 'Sim')
      else if (filtroAprovadoFinanc === 'Não') q = q.eq('aprovado_financiadora', 'Não')
      else if (filtroAprovadoFinanc === '__sem__') q = q.or('aprovado_financiadora.is.null,aprovado_financiadora.eq.""')
      if (filtroNomeDebounce.trim()) q = q.ilike('nome', `%${filtroNomeDebounce.trim()}%`)
      if (filtroCpfDebounce.trim()) q = q.ilike('cpf', `%${filtroCpfDebounce.trim().replace(/\D/g, '')}%`)

      const { data, error } = await q.limit(500)
      if (!error) setLeads(data || [])
    } catch (e) {
      console.error('Erro ao carregar leads:', e)
      setLeads([])
    } finally {
      setLoadingLeads(false)
    }
  }, [filtroStatus, filtroAprovadoFinanc, filtroNomeDebounce, filtroCpfDebounce])

  useEffect(() => {
    carregarLeads()
  }, [carregarLeads])

  useEffect(() => {
    const carregarEmpresas = async () => {
      try {
        const { data, error } = await supabase.from('empresa').select('id, nome').order('nome')
        if (!error && data?.length) setEmpresas(data)
      } catch (e) {
        console.warn('Erro ao carregar empresas:', e)
      }
    }
    carregarEmpresas()
  }, [])

  useEffect(() => {
    const carregarBancos = async () => {
      try {
        const { data, error } = await supabase
          .from('bancos_financiadora')
          .select('id, nome')
          .eq('ativo', true)
          .order('nome')
        if (!error) setBancos(data || [])
      } catch (e) {
        console.warn('Erro ao carregar bancos:', e)
      }
    }
    carregarBancos()
  }, [])

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    setErro('')
    setResultado(null)
    setLoading(true)

    try {
      const text = await file.text()
      const parseResult = parseCsvLeads(text, separador)

      if (parseResult.validos.length === 0) {
        setResultado({
          importados: 0,
          duplicados: 0,
          invalidos: parseResult.invalidos.length,
          invalidosLista: parseResult.invalidos,
          duplicadosLista: []
        })
        setLoading(false)
        return
      }

      const cpfs = parseResult.validos.map((v) => v.cpf)
      const { data: existentes } = await supabase
        .from('leads_capacitacao')
        .select('cpf')
        .in('cpf', cpfs)
      const setExistentes = new Set((existentes || []).map((r) => r.cpf))

      const setCsvVistos = new Set()
      const paraInserir = []
      const duplicados = []

      for (const v of parseResult.validos) {
        if (setExistentes.has(v.cpf) || setCsvVistos.has(v.cpf)) {
          duplicados.push(v)
        } else {
          setCsvVistos.add(v.cpf)
          paraInserir.push(v)
        }
      }

      let importados = 0
      const empresaId = idEmpresa || (userEmpresa?.id ?? userEmpresa) || null

      for (const item of paraInserir) {
        try {
          const { error } = await supabase.from('leads_capacitacao').insert({
            cpf: item.cpf,
            nome: item.nome,
            data_nascimento: item.data_nascimento,
            telefone: item.telefone,
            id_responsavel: userId || null,
            id_empresa: empresaId || null,
            status: 'Novo'
          })
          if (!error) importados++
        } catch (err) {
          if (err.code === '23505') duplicados.push(item)
        }
      }

      setResultado({
        importados,
        duplicados: duplicados.length,
        invalidos: parseResult.invalidos.length,
        invalidosLista: parseResult.invalidos,
        duplicadosLista: duplicados
      })
      carregarLeads()
    } catch (err) {
      setErro(err?.message || 'Erro ao processar arquivo.')
    } finally {
      setLoading(false)
      e.target.value = ''
    }
  }

  const abrirModalStatus = async (lead) => {
    setModalStatus({ show: true, lead })
    setEditStatus(lead.status || 'Novo')
    setEditObservacao(lead.observacao || '')
    setHistorico([])
    try {
      const { data } = await supabase
        .from('leads_capacitacao_historico')
        .select('id, tipo_alteracao, nome_usuario, status_anterior, status_novo, observacao, aprovado_financiadora, banco_financiadora, valor_financiadora, data_alteracao')
        .eq('id_lead', lead.id)
        .order('data_alteracao', { ascending: false })
      setHistorico(data || [])
    } catch (e) {
      console.warn('Erro ao carregar histórico:', e)
    }
  }

  const fecharModalStatus = () => {
    setModalStatus({ show: false, lead: null })
    setHistorico([])
    setEditStatus('')
    setEditObservacao('')
    setSalvandoStatus(false)
  }

  const salvarStatus = async () => {
    if (!modalStatus.lead) return
    setSalvandoStatus(true)
    const statusAnterior = modalStatus.lead.status || 'Novo'
    const mudouStatus = editStatus !== statusAnterior
    try {
      const { error } = await supabase
        .from('leads_capacitacao')
        .update({ status: editStatus, observacao: editObservacao.trim() || null })
        .eq('id', modalStatus.lead.id)
      if (!error) {
        if (mudouStatus) {
          await supabase.from('leads_capacitacao_historico').insert({
            id_lead: modalStatus.lead.id,
            id_usuario: userId || null,
            nome_usuario: userName || null,
            status_anterior: statusAnterior,
            status_novo: editStatus,
            observacao: editObservacao.trim() || null
          })
          setHistorico((prev) => [
            {
              id: Date.now(),
              status_anterior: statusAnterior,
              status_novo: editStatus,
              observacao: editObservacao.trim() || null,
              data_alteracao: new Date().toISOString(),
              nome_usuario: userName
            },
            ...prev
          ])
        }
        setLeads((prev) =>
          prev.map((l) =>
            l.id === modalStatus.lead.id
              ? { ...l, status: editStatus, observacao: editObservacao.trim() || null }
              : l
          )
        )
        fecharModalStatus()
      }
    } catch (e) {
      console.error(e)
    } finally {
      setSalvandoStatus(false)
    }
  }

  const abrirModalFinanc = (lead) => {
    setModalFinanc({ show: true, lead })
    setEditAprovado(lead.aprovado_financiadora || '')
    setEditBanco(lead.banco_financiadora || '')
    setEditValor(lead.valor_financiadora != null ? formatarMoedaInput(String(Math.round(lead.valor_financiadora * 100))) : '')
  }

  const fecharModalFinanc = () => {
    setModalFinanc({ show: false, lead: null })
  }

  const handleValorFinancChange = (e) => {
    const formatted = formatarMoedaInput(e.target.value)
    setEditValor(formatted)
  }

  const salvarFinanciadora = async () => {
    if (!modalFinanc.lead) return
    setSalvandoFinanc(true)
    const ant = modalFinanc.lead
    const valorNum = parseMoedaBR(editValor)
    const mudou = editAprovado !== (ant.aprovado_financiadora || '') ||
      editBanco !== (ant.banco_financiadora || '') ||
      valorNum !== (ant.valor_financiadora != null ? ant.valor_financiadora : null)
    try {
      const { error } = await supabase
        .from('leads_capacitacao')
        .update({
          aprovado_financiadora: editAprovado || null,
          banco_financiadora: editBanco.trim() || null,
          valor_financiadora: valorNum
        })
        .eq('id', modalFinanc.lead.id)
      if (!error) {
        if (mudou) {
          await supabase.from('leads_capacitacao_historico').insert({
            id_lead: modalFinanc.lead.id,
            id_usuario: userId || null,
            nome_usuario: userName || null,
            tipo_alteracao: 'financiadora',
            status_novo: '-',
            aprovado_financiadora: editAprovado || null,
            banco_financiadora: editBanco.trim() || null,
            valor_financiadora: valorNum,
            observacao: `Aprovado: ${editAprovado || '—'} | Banco: ${editBanco.trim() || '—'} | Valor: ${formatarMoeda(valorNum)}`
          })
        }
        setLeads((prev) =>
          prev.map((l) =>
            l.id === modalFinanc.lead.id
              ? { ...l, aprovado_financiadora: editAprovado || null, banco_financiadora: editBanco.trim() || null, valor_financiadora: valorNum }
              : l
          )
        )
        fecharModalFinanc()
      }
    } catch (e) {
      console.error(e)
    } finally {
      setSalvandoFinanc(false)
    }
  }

  const textoFinanciadora = (l) => {
    if (!l.aprovado_financiadora) return '—'
    const partes = [l.aprovado_financiadora]
    if (l.banco_financiadora) partes.push(l.banco_financiadora)
    if (l.valor_financiadora != null) partes.push(formatarMoeda(l.valor_financiadora))
    return partes.join(' • ')
  }

  return (
    <div className="leads-capacitacao-container">
      <div className="leads-capacitacao-header">
        <button type="button" className="leads-capacitacao-btn-back" onClick={onBack}>
          ← Voltar
        </button>
        <h1 className="leads-capacitacao-title">📥 Leads Capacitação</h1>
        <p className="leads-capacitacao-desc">
          Importe um arquivo CSV (sem cabeçalho). Colunas na ordem: <strong>CPF, Nome, Data de nascimento, Telefone</strong>
        </p>
      </div>

      <div className="leads-capacitacao-content">
        {erro && <div className="alert alert-danger">{erro}</div>}

        <details className="leads-capacitacao-expandir-csv">
          <summary>Importar CSV</summary>
          <div className="leads-capacitacao-card">
          <div className="form-row-captar">
            <div className="form-group-captar">
              <label>Separador</label>
              <select value={separador} onChange={(e) => setSeparador(e.target.value)}>
                <option value=",">Vírgula (,)</option>
                <option value=";">Ponto e vírgula (;)</option>
              </select>
            </div>
            {empresas.length > 0 && (
              <div className="form-group-captar">
                <label>Empresa</label>
                <select value={idEmpresa} onChange={(e) => setIdEmpresa(e.target.value)}>
                  <option value="">— Selecionar —</option>
                  {empresas.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.nome}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
          <div className="form-group-captar">
            <label>Arquivo CSV</label>
            <input
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              disabled={loading}
              className="form-control"
            />
          </div>
          {loading && <p className="text-muted mt-2">Importando...</p>}
          </div>
        </details>

        <div className="leads-capacitacao-card">
          <h3 className="mb-3">Lista de Leads</h3>
          <div className="filtros-leads">
            <div className="form-group-captar">
              <label>Status</label>
              <select
                value={filtroStatus}
                onChange={(e) => setFiltroStatus(e.target.value)}
                className="form-control form-control-sm"
              >
                {STATUS_OPCOES.map((o) => (
                  <option key={o.value || 'all'} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
            <div className="form-group-captar">
              <label>Aprov. Financ.</label>
              <select
                value={filtroAprovadoFinanc}
                onChange={(e) => setFiltroAprovadoFinanc(e.target.value)}
                className="form-control form-control-sm"
              >
                {APROVADO_FINANCIADORA_OPCOES.map((o) => (
                  <option key={o.value || 'all'} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
            <div className="form-group-captar">
              <label>Nome</label>
              <input
                type="text"
                value={filtroNome}
                onChange={(e) => setFiltroNome(e.target.value)}
                placeholder="Buscar por nome..."
                className="form-control form-control-sm"
              />
            </div>
            <div className="form-group-captar">
              <label>CPF</label>
              <input
                type="text"
                value={filtroCpf}
                onChange={(e) => setFiltroCpf(e.target.value)}
                placeholder="Buscar por CPF..."
                className="form-control form-control-sm"
              />
            </div>
          </div>

          {loadingLeads ? (
            <p className="text-muted mt-3">Carregando...</p>
          ) : (
            <div className="table-responsive mt-3" style={{ maxHeight: 400, overflow: 'auto' }}>
              <table className="table table-sm table-hover">
                <thead className="table-light sticky-top">
                  <tr>
                    <th>CPF</th>
                    <th>Nome</th>
                    <th>Data Nasc.</th>
                    <th>Telefone</th>
                    <th>Status</th>
                    <th title="Aprovado Financiadora">Aprov. Financ.</th>
                    <th>Observação</th>
                    <th>Data Cadastro</th>
                  </tr>
                </thead>
                <tbody>
                  {leads.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center text-muted py-4">
                        Nenhum lead encontrado.
                      </td>
                    </tr>
                  ) : (
                    leads.map((l) => (
                      <tr key={l.id}>
                        <td>{formatarCpf(l.cpf)}</td>
                        <td>{l.nome}</td>
                        <td>{l.data_nascimento ? new Date(l.data_nascimento).toLocaleDateString('pt-BR') : '—'}</td>
                        <td>{l.telefone || '—'}</td>
                        <td>
                        <button
                          type="button"
                          className="badge badge-status-clicavel"
                          style={{ backgroundColor: getStatusColor(l.status), color: '#fff' }}
                          onClick={() => abrirModalStatus(l)}
                          title="Clique para alterar"
                        >
                          {l.status || 'Novo'}
                        </button>
                      </td>
                        <td>
                          <button
                            type="button"
                            className="celula-financiadora"
                            onClick={() => abrirModalFinanc(l)}
                            title={textoFinanciadora(l)}
                          >
                            {l.aprovado_financiadora ? `${l.aprovado_financiadora}${l.banco_financiadora ? ' • ' + l.banco_financiadora : ''}${l.valor_financiadora != null ? ' • ' + formatarMoeda(l.valor_financiadora) : ''}` : '—'}
                          </button>
                        </td>
                        <td className="obs-cell">{l.observacao ? <span title={l.observacao}>{l.observacao.length > 40 ? `${l.observacao.slice(0, 40)}...` : l.observacao}</span> : '—'}</td>
                        <td>{l.data_cadastrado ? new Date(l.data_cadastrado).toLocaleDateString('pt-BR') : '—'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {resultado && (
          <div className="leads-capacitacao-resultado">
            <h2>Resultado da importação</h2>
            <div className="resultado-cards-captar">
              <div className="resultado-card-captar success">
                <span className="numero">{resultado.importados}</span>
                <span className="label">Importados</span>
              </div>
              <div className="resultado-card-captar warning">
                <span className="numero">{resultado.duplicados}</span>
                <span className="label">Duplicados</span>
              </div>
              <div className="resultado-card-captar error">
                <span className="numero">{resultado.invalidos}</span>
                <span className="label">Inválidos</span>
              </div>
            </div>

            {resultado.invalidosLista?.length > 0 && (
              <details className="resultado-detalhes-captar">
                <summary>Ver linhas inválidas</summary>
                <div className="table-responsive" style={{ maxHeight: 300, overflow: 'auto' }}>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Linha</th>
                        <th>CPF</th>
                        <th>Nome</th>
                        <th>Motivo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {resultado.invalidosLista.map((r, i) => (
                        <tr key={i}>
                          <td>{r.linha}</td>
                          <td>{r.cpfFormatado || r.cpf}</td>
                          <td>{r.nome}</td>
                          <td>{r.motivo}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </details>
            )}

            {resultado.duplicadosLista?.length > 0 && (
              <details className="resultado-detalhes-captar">
                <summary>Ver duplicados (CPF já existente)</summary>
                <div className="table-responsive" style={{ maxHeight: 300, overflow: 'auto' }}>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Linha</th>
                        <th>CPF</th>
                        <th>Nome</th>
                      </tr>
                    </thead>
                    <tbody>
                      {resultado.duplicadosLista.map((r, i) => (
                        <tr key={i}>
                          <td>{r.linha}</td>
                          <td>{r.cpf}</td>
                          <td>{r.nome}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </details>
            )}
          </div>
        )}

        {modalFinanc.show && modalFinanc.lead && (
          <div className="modal-leads-overlay" onClick={fecharModalFinanc}>
            <div className="modal-leads-content modal-financiadora" onClick={(e) => e.stopPropagation()}>
              <div className="modal-leads-header">
                <h4>Aprovado Financiadora</h4>
                <button type="button" className="modal-leads-close" onClick={fecharModalFinanc} aria-label="Fechar">×</button>
              </div>
              <div className="modal-leads-body">
                <p className="modal-leads-nome">{modalFinanc.lead.nome}</p>
                <p className="modal-leads-cpf text-muted">{formatarCpf(modalFinanc.lead.cpf)}</p>
                <div className="form-group-captar mt-3">
                  <label>Aprovado?</label>
                  <select value={editAprovado} onChange={(e) => setEditAprovado(e.target.value)} className="form-control">
                    <option value="">— Selecionar —</option>
                    <option value="Sim">Sim</option>
                    <option value="Não">Não</option>
                  </select>
                </div>
                <div className="form-group-captar mt-3">
                  <label>Banco</label>
                  <select value={editBanco} onChange={(e) => setEditBanco(e.target.value)} className="form-control">
                    <option value="">— Selecionar —</option>
                    {bancos.map((b) => (
                      <option key={b.id} value={b.nome}>{b.nome}</option>
                    ))}
                    {editBanco && !bancos.some((b) => b.nome === editBanco) && (
                      <option value={editBanco}>{editBanco} (cadastro anterior)</option>
                    )}
                  </select>
                </div>
                <div className="form-group-captar mt-3">
                  <label>Valor (R$)</label>
                  <input type="text" value={editValor} onChange={handleValorFinancChange} placeholder="0,00" className="form-control" />
                </div>
              </div>
              <div className="modal-leads-footer">
                <button type="button" className="btn btn-outline-secondary" onClick={fecharModalFinanc}>Cancelar</button>
                <button type="button" className="btn btn-primary" onClick={salvarFinanciadora} disabled={salvandoFinanc}>{salvandoFinanc ? 'Salvando...' : 'Salvar'}</button>
              </div>
            </div>
          </div>
        )}

        {modalStatus.show && modalStatus.lead && (
          <div className="modal-leads-overlay" onClick={fecharModalStatus}>
            <div className="modal-leads-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-leads-header">
                <h4>Alterar status</h4>
                <button type="button" className="modal-leads-close" onClick={fecharModalStatus} aria-label="Fechar">
                  ×
                </button>
              </div>
              <div className="modal-leads-body">
                <p className="modal-leads-nome">{modalStatus.lead.nome}</p>
                <p className="modal-leads-cpf text-muted">{formatarCpf(modalStatus.lead.cpf)}</p>
                <div className="form-group-captar mt-3">
                  <label>Status</label>
                  <select
                    value={editStatus}
                    onChange={(e) => setEditStatus(e.target.value)}
                    className="form-control"
                  >
                    {STATUS_SELECT_OPCOES.map((o) => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group-captar mt-3">
                  <label>Observação</label>
                  <textarea
                    value={editObservacao}
                    onChange={(e) => setEditObservacao(e.target.value)}
                    placeholder="Adicione uma observação..."
                    rows={3}
                    className="form-control"
                  />
                </div>
                {historico.length > 0 && (
                  <div className="modal-leads-historico mt-3">
                    <label>Histórico de alterações</label>
                    <ul className="historico-list">
                      {historico.map((h) => (
                        <li key={h.id}>
                          <strong>{h.nome_usuario || 'Sistema'}</strong>
                          {h.tipo_alteracao === 'financiadora' ? (
                            <> atualizou Aprov. Financiadora: {h.aprovado_financiadora || '—'}
                              {h.banco_financiadora && ` | Banco: ${h.banco_financiadora}`}
                              {h.valor_financiadora != null && ` | ${formatarMoeda(h.valor_financiadora)}`}
                            </>
                          ) : (
                            <> alterou para{' '}
                              <span className="badge" style={{ backgroundColor: getStatusColor(h.status_novo), color: '#fff' }}>{h.status_novo}</span>
                              {h.observacao && <span className="historico-obs"> — {h.observacao}</span>}
                            </>
                          )}
                          {' '}em {h.data_alteracao ? new Date(h.data_alteracao).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—'}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <div className="modal-leads-footer">
                <button type="button" className="btn btn-outline-secondary" onClick={fecharModalStatus}>
                  Cancelar
                </button>
                <button type="button" className="btn btn-primary" onClick={salvarStatus} disabled={salvandoStatus}>
                  {salvandoStatus ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default LeadsCapacitacao
